import { render, staticRenderFns } from "./upload-date-presenter.vue?vue&type=template&id=4063c7f2&scoped=true&"
import script from "./upload-date-presenter.vue?vue&type=script&lang=js&"
export * from "./upload-date-presenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063c7f2",
  null
  
)

export default component.exports